import { memo } from "react";
import { useTranslation } from "react-i18next";
import vars from "utils/vars";

const FooterCopyRights = ({ className = "" }) => {
	const { t } = useTranslation();

	return (
		<p className={`fw-light small text-capitalize mb-0 text-center ${className}`}>
			<small>
				{t("content.copy_rights", { year: new Date().getFullYear() })}
				<span className="text-uppercase mx-1">{vars.app.name}</span>
				{t("content.all_rights_reserved")}
			</small>
		</p>
	);
};

export default memo(FooterCopyRights);
